import { WritableSignal, Signal, Injectable, Injector } from "@angular/core";
import { InspectionJob, Lot, Area, JobIssue, Media, Zone, Component, Assertion, AssertionIssue } from "../../../core/database/db";
import { BqInspectionDataService } from "../../../domains/jobs/services/bq-inspection-data.service";
import { BqInspectionSingleAreaDataService } from "../../../domains/jobs/services/bq-inspection-single-area-data.service";
import { BqInspectionDiscussAndDemonstrateDataService } from "../../../domains/jobs/services/bq-inspection-discuss-and-demonstrate-data.service";
import { Bq9DataService } from "../../cm/pages/bq9/services/bq9-data.service";
import { AreaConfigurationDTO } from "../../../domains/areas/models/configuration/AreaConfigurationDTO";

export interface BqStepDataService {
  job: WritableSignal<InspectionJob | undefined>;
  lot: WritableSignal<Lot | undefined>;
  areas: WritableSignal<Area[] | undefined>;
  jobIssues: WritableSignal<JobIssue[] | undefined>;
  media: WritableSignal<Media[] | undefined>;
  zones: WritableSignal<Zone[] | undefined>;
  areasConfig: WritableSignal<AreaConfigurationDTO[] | undefined>;
  components: WritableSignal<Component[] | undefined>;
  assertions: WritableSignal<Assertion[] | undefined>;
  assertionIssues: WritableSignal<AssertionIssue[] | undefined>;
  hasData: Signal<boolean>;
  isCcmInspection: Signal<boolean>;
  isRefreshingInBackground: Signal<boolean>;
  dataUpdatedPulse: Signal<boolean>;
}

@Injectable()
export class BqStepDataServiceFactory {
  constructor(private injector: Injector) { }

  getService<T extends BqStepDataService>(bqStep: string): T {
    switch (bqStep) {
      case "BQ9":
        return this.injector.get(Bq9DataService) as unknown as T;
      // The single-area steps answer one checklist, so they get the response model on top of the base data.
      case "BQ2":
      case "BQ3":
      case "BQ4":
        return this.injector.get(BqInspectionSingleAreaDataService) as unknown as T;
      // BQ1/BQ5 pair a standalone punchlist with a "reviewed with homeowner" checklist. BQ8 is the
      // same shape, just an older step that was once bespoke.
      case "BQ1":
      case "BQ5":
      case "BQ8":
        return this.injector.get(BqInspectionDiscussAndDemonstrateDataService) as unknown as T;
      default:
        return this.injector.get(BqInspectionDataService) as unknown as T;
    }
  }
}